export default __webpack_public_path__ + "static/media/edit.266c5421.svg";